import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '../Typography';

import { MapInfoCard } from './MapInfoCard';

type Props = {
  closeCard: (value: boolean) => void;
  cityName: string;
  countryName?: string;
  totalNationalProgrammes?: number;
  totalRegionalProgrammes?: number;
  totalStudiesProgrammes?: number;
  totalClinicalProgrammes?: number;
};

export const CityCard: FC<Props> = ({
  closeCard,
  cityName,
  countryName,
  totalNationalProgrammes,
  totalRegionalProgrammes,
  totalClinicalProgrammes,
  totalStudiesProgrammes,
}) => {
  const { t } = useTranslation();

  const headerFields = [
    {
      label: t('card.city'),
      value: cityName,
    },
    ...(countryName
      ? [
          {
            label: t('card.country'),
            value: countryName,
          },
        ]
      : []),
  ];

  const cardBody = (
    <Typography variant="p2">
      <ul>
        <li style={{ marginBottom: 0 }}>
          {t('card.nationalProgrammes')}:{' '}
          <span style={{ color: '#5A5A5A' }}>
            {totalNationalProgrammes ?? 0}
          </span>
        </li>
        <li style={{ marginBottom: 0 }}>
          {t('card.regionalProgrammes')}:{' '}
          <span style={{ color: '#5A5A5A' }}>
            {totalRegionalProgrammes ?? 0}
          </span>
        </li>
        <li style={{ marginBottom: 0 }}>
          {t('card.implementationStudies')}:{' '}
          <span style={{ color: '#5A5A5A' }}>
            {totalStudiesProgrammes ?? 0}
          </span>
        </li>
        <li style={{ marginBottom: 0 }}>
          {t('card.clinicalTrials')}:{' '}
          <span style={{ color: '#5A5A5A' }}>
            {totalClinicalProgrammes ?? 0}
          </span>
        </li>
      </ul>
    </Typography>
  );

  return (
    <MapInfoCard closeCard={closeCard} headerFields={headerFields}>
      {cardBody}
    </MapInfoCard>
  );
};
